import React from 'react';
import classNames from 'classnames';
import { IconVolume, IconVolumeOff, IconVolume2 } from '@tabler/icons-react';
import s from './custom-video-player.module.scss';

// В @tabler/icons-react v2: IconVolume = 2 волны (громко), IconVolume2 = 1 волна (тихо),
// IconVolume3 = динамик с крестиком (не «максимум», не используем).
//
// ВАЖНО: состояние иконки ('high' | 'low' | 'off') передаём пропом, а НЕ меняем тип
// компонента. Смена типа (IconVolume -> IconVolume2) посреди нативного drag размонтирует
// SVG, и Chrome отменяет drag — ползунок откатывается к значению начала drag (100%).
// Все три иконки смонтированы постоянно, переключение — через CSS-видимость.
export const VolumeIndicator = ({ size, state }) => (
	<span className={s.volumeIconSet} style={{ width: size, height: size }} aria-hidden="true">
		<IconVolume size={size} className={classNames(s.volumeIcon, state !== 'high' && s.volumeIconHidden)} />
		<IconVolume2 size={size} className={classNames(s.volumeIcon, state !== 'low' && s.volumeIconHidden)} />
		<IconVolumeOff size={size} className={classNames(s.volumeIcon, state !== 'off' && s.volumeIconHidden)} />
	</span>
);
